import apiService from "@/services/api.service";
import jwt_decode   from "jwt-decode";
import authUser from "@/models/authUser";
import authError  from "@/errors/authError";

//state
const state = () => ({
	accessToken: '',
	roles:[],
	user:{},
	isSignedIn:  false,
	fresh: true,
	working:true
})

//getters
const getters = {

}

// actions
const actions = {

	/**
	 *
	 * @param commit
	 * @param dispatch
	 * @returns {Promise<void>}
	 * @throws {authError}
	 */
	initialize:async function({commit, dispatch}) {
		//commit( 'ui/authenticating', true, { root: true } );
		await commit('setWorking', true);
		await commit('setModuleStateFromLocalStorage');
		await dispatch('getAccessToken');
		commit('setFresh', true);
		await commit('setWorking', false);
		//commit( 'ui/authenticating', false, { root: true } );
	},

	/**
	 *
	 * @param state
	 * @param commit
	 * @returns {Promise<string>}
	 * @throws {authError}
	 */
	getAccessToken:async function({state, commit}) {
		let getNewToken = false;

		try {
			let decodedCurrentAccessToken = jwt_decode( state.accessToken );
			if (Date.now() >= (decodedCurrentAccessToken.exp * 1000)) {
				getNewToken = true;
			}
		}
		catch(e) {
			getNewToken = true;
		}

		if(getNewToken) {
			let api = apiService();
			let accessToken = await api.authenticate();
			commit('setDataFromToken', accessToken);
			return accessToken;
		}
		else {
			return state.accessToken;
		}
	},

}

// mutations
const mutations = {

	setDataFromToken:function(state,accessToken) {

		try {
			let decodedAccessToken = jwt_decode(accessToken);
			state.accessToken = accessToken;
			state.roles = decodedAccessToken.scope;
			state.user = new authUser( decodedAccessToken.data );
			state.isSignedIn = true;
		}
		catch(e) {
			console.log(e);
			throw new authError('Invalid authentication token provided by Signatures API', 500, e);
		}
	},

	setFresh: function ( state, fresh ) {
		state.fresh = fresh;
	},

	setModuleStateFromLocalStorage:function(state) {
		if ( localStorage.getItem( 'store.signaturesApiAuth' ) ) {
			// Replace the state object with the stored item
			let data = JSON.parse( localStorage.getItem( 'store.signaturesApiAuth' ) );
			if(data!==null) {
				data.fresh = false;
				Object.assign(state, data)
			}
		}
	},
	setWorking:function(state, val) {
		state.working = val;
	}

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
